import React from "react";

export const useExtraServices = (
  AvailableExtraServices,
  setSelectedServices
) => {
  // Zorunlu ek servisleri hesapla
  const mandatoryServices = React.useMemo(() => {
    if (!AvailableExtraServices) return [];

    const serviceMap = new Map();

    AvailableExtraServices.forEach((day) => {
      day.extraServices.forEach((service) => {
        if (service.IsOptional === "0") {
          const key = `${service.id}-${service.title}`;
          if (!serviceMap.has(key)) {
            serviceMap.set(key, {
              ...service,
              totalDays: 1,
            });
          } else {
            const existing = serviceMap.get(key);
            existing.totalDays += 1;
            serviceMap.set(key, existing);
          }
        }
      });
    });

    return Array.from(serviceMap.values());
  }, [AvailableExtraServices]);

  // Opsiyonel ek servisleri hesapla
  const optionalServices = React.useMemo(() => {
    if (!AvailableExtraServices) return [];

    const serviceMap = new Map();

    AvailableExtraServices.forEach((day) => {
      day.extraServices.forEach((service) => {
        if (service.IsOptional === "1") {
          const key = `${service.id}-${service.title}`;
          if (!serviceMap.has(key)) {
            serviceMap.set(key, {
              ...service,
              totalDays: 1,
            });
          } else {
            const existing = serviceMap.get(key);
            existing.totalDays += 1;
            serviceMap.set(key, existing);
          }
        }
      });
    });

    return Array.from(serviceMap.values());
  }, [AvailableExtraServices]);

  // Servis seçimi değiştiğinde
  const handleServiceChange = (serviceId) => {
    setSelectedServices((prev) => {
      const newSelected = new Set(prev);
      if (newSelected.has(serviceId)) {
        newSelected.delete(serviceId);
      } else {
        newSelected.add(serviceId);
      }

      return newSelected;
    });
  };

  return { mandatoryServices, optionalServices, handleServiceChange };
};
